import React, { useState } from "react";
import axios from "axios";
import { useAuthStore } from "../store/authStore";

const CreditsForm = ({ onClose }) => {
  const [evaluations, setEvaluations] = useState(0);
  const [creditsRequired, setCreditsRequired] = useState(0);
  const [amountToPay, setAmountToPay] = useState(0);

  const { user, updateCredits } = useAuthStore(); // Get user and updateCredits method from auth store

  // Update credits and amount when evaluations are changed
  const handleEvaluationsChange = (e) => {
    const evalCount = parseInt(e.target.value, 10);
    if (isNaN(evalCount) || evalCount <= 0) {
      setEvaluations(0);
      setCreditsRequired(0);
      setAmountToPay(0);
      return;
    }
    setEvaluations(evalCount);
    setCreditsRequired(evalCount * 5);
    setAmountToPay(evalCount * 49);
  };

  // Handle Razorpay Payment
  const handlePayment = async () => {
    if (evaluations <= 0) {
      alert("Please enter a valid number of evaluations");
      return;
    }

    // Step 1: Create an order on the backend
    const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/transaction/create-order`, {
        amount: amountToPay, // Pass the amount to backend
      });
  
    const { id: orderId } = data.order; // Extract orderId from backend response

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Replace with your Razorpay key
      amount: amountToPay * 100, // Razorpay expects the amount in paise (1 Rs = 100 paise)
      currency: "INR",
      name: "Write Along",
      description: "Credits Purchase",
      image: "https://iwritealong.com/wp-content/uploads/2024/06/we.png", // Optional: Add a logo
      order_id: orderId,
      handler: function (response) {
        // On successful payment
        console.log("Payment successful", response);

        // Send payment details to the backend for verification
        axios
          .post(`${process.env.REACT_APP_BACKEND_URL}/api/transaction/verify-payment`, {
            paymentId: response.razorpay_payment_id,
            orderId: response.razorpay_order_id,
            signature: response.razorpay_signature,
          })
          .then((res) => {
            if (res.data.success) {
              alert("Payment verified and credits added successfully!");
              // Update credits in auth store
              updateCredits(res.data.updatedCredits); // Assuming backend sends updated credits
              onClose();
            } else {
              alert("Payment verification failed!");
            }
          })
          .catch((err) => {
            console.error("Error verifying payment:", err);
            alert("An error occurred during payment verification.");
          });
      },
      prefill: {
        name: user?.name || "",
        email: user?.email || "",
      },
      theme: {
        color: "#528FF0",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  };

  return (
  <div className="flex items-center justify-center min-h-screen bg-gray-900">
    <div className="w-96 h-auto bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col justify-center relative">
      {/* Close Button */}
      <button
        onClick={onClose} // Close the form when the close button is clicked
        className="absolute top-2 right-2 text-gray-200 hover:text-red-500 text-xl font-bold"
      >
        &times;
      </button>

      <div className="mb-4">
        <label htmlFor="evaluations" className="text-gray-200 font-semibold">
          Enter number of evaluations:
        </label>
        <input
          id="evaluations"
          type="number"
          value={evaluations}
          onChange={handleEvaluationsChange}
          className="w-full p-2 mt-2 border border-gray-600 rounded-md bg-gray-700 text-gray-200"
          min="1"
        />
      </div>

      {evaluations > 0 && (
        <div className="mb-4">
          <p className="text-gray-300">Credits Required: {creditsRequired}</p>
          <p className="text-gray-300">Amount to Pay: ₹{amountToPay}</p>
        </div>
      )}

      <button
        onClick={handlePayment}
        className="w-full py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-lg hover:bg-gradient-to-r hover:from-blue-600 hover:to-blue-700"
      >
        Make Payment
      </button>
    </div>
  </div>


  );
};

export default CreditsForm;
